// extracted by mini-css-extract-plugin
module.exports = {"image":"Description_image__N_sjm","description":"Description_description__NCy7v"};